import { useTranslation } from 'react-i18next';
import { Field, Panel, Select } from '../components/ui.tsx';
import { LANGUAGES } from '../i18n/index.ts';
import { WEB_MODULES } from '../modules/index.ts';
import { ReadingSection } from './account-reading.tsx';

/** As seções que os módulos instalados somam a Perfil (ADR 0131). */
const MODULE_ACCOUNT_SECTIONS = WEB_MODULES.flatMap((m) => m.accountSections ?? []);

/** Aba Perfil de Minha conta (ADR 0139): os dados da pessoa, o idioma e a leitura. */
export function ProfileTab({ name, email }: { name: string; email: string }) {
  const { t, i18n } = useTranslation();
  return (
    <>
      <Panel title={t('account.profile')}>
        <dl className="grid gap-3 text-sm sm:grid-cols-2">
          <div className="flex flex-col gap-0.5">
            <dt className="text-muted">{t('account.name')}</dt>
            <dd className="font-medium">{name}</dd>
          </div>
          <div className="flex flex-col gap-0.5">
            <dt className="text-muted">{t('account.email')}</dt>
            <dd className="break-all">{email}</dd>
          </div>
        </dl>
      </Panel>
      <Panel title={t('account.preferences')}>
        <Field label={t('common.language')} hint={t('account.languageHint')} className="max-w-xs">
          <Select
            id="language"
            value={i18n.language}
            onChange={(e) => void i18n.changeLanguage(e.target.value)}
          >
            {LANGUAGES.map((l) => (
              <option key={l.code} value={l.code}>
                {l.label}
              </option>
            ))}
          </Select>
        </Field>
      </Panel>
      <ReadingSection />
      {MODULE_ACCOUNT_SECTIONS.map((Section, i) => (
        <Section key={i} />
      ))}
    </>
  );
}
